/**
 * Plano — estado do plano do escritório (freemium) + comparativo + contato.
 */
import { Link } from 'react-router-dom';
import { useMe } from '../hooks';

const LINHAS = [
  { recurso: 'Coleta DJEN da OAB do escritório', free: true, pro: true },
  { recurso: 'Kanban semanal e mensal',          free: true, pro: true },
  { recurso: 'Triagem automática por IA',        free: true, pro: true },
  { recurso: 'Agenda de audiências',             free: true, pro: true },
  { recurso: 'Mapa do caso + blocos da petição', free: false, pro: true },
  { recurso: 'Refino conversacional com IA',     free: false, pro: true },
  { recurso: 'Jurisprudência (Falcão/JT)',       free: false, pro: true },
  { recurso: 'Petição final em papel timbrado',  free: false, pro: true },
];

export function Plano() {
  const { data: me } = useMe();
  const esc = me?.escritorio;
  const pro = esc?.plano === 'pro';

  return (
    <div className="max-w-3xl mx-auto px-6 py-10">
      <Link to="/semanal" className="text-sm text-blue-600 dark:text-blue-400 hover:underline">← Voltar ao kanban</Link>
      <h1 className="mt-3 font-display text-2xl font-bold text-slate-900 dark:text-slate-100">Plano do escritório</h1>

      <div className={`mt-5 rounded-2xl border p-6 ${pro
        ? 'border-amber-400/40 bg-amber-500/5'
        : 'border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900/60'}`}>
        <div className="flex items-center justify-between">
          <div>
            <div className="text-sm text-slate-500 dark:text-slate-400">{esc?.nome ?? '—'}</div>
            <div className="mt-1 font-display text-xl font-bold text-slate-900 dark:text-slate-100">
              {pro ? '⭐ Plano Pro' : 'Plano Free'}
            </div>
            {esc?.oab_numero && (
              <div className="mt-1 text-xs text-slate-500">OAB monitorada: {esc.oab_numero}/{esc.oab_uf}</div>
            )}
          </div>
          {!pro && (
            <a href="mailto:gestor.icit@gmail.com?subject=Upgrade%20para%20o%20plano%20Pro%20—%20Agenda%20TRT-1"
               className="px-5 py-2.5 rounded-xl bg-blue-600 hover:bg-blue-500 text-white text-sm font-semibold transition">
              Falar com a gente
            </a>
          )}
        </div>
        {!pro && (
          <p className="mt-4 text-sm text-slate-600 dark:text-slate-400 leading-relaxed">
            O plano Pro libera a geração de peças com IA usando a <strong>conta Claude do seu
            escritório</strong> — o consumo fica sob seu controle, por escritório.
          </p>
        )}
      </div>

      <div className="mt-8 rounded-2xl border border-slate-200 dark:border-slate-800 overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-slate-50 dark:bg-slate-900 text-slate-600 dark:text-slate-300">
              <th className="text-left px-5 py-3 font-semibold">Recurso</th>
              <th className="px-5 py-3 font-semibold w-20">Free</th>
              <th className="px-5 py-3 font-semibold w-20 text-amber-500">Pro</th>
            </tr>
          </thead>
          <tbody>
            {LINHAS.map((l, i) => (
              <tr key={l.recurso} className={i % 2 ? 'bg-slate-50/50 dark:bg-slate-900/40' : ''}>
                <td className="px-5 py-2.5 text-slate-700 dark:text-slate-300">{l.recurso}</td>
                <td className="px-5 py-2.5 text-center">{l.free ? '✓' : '—'}</td>
                <td className="px-5 py-2.5 text-center">✓</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
